(function() {
  'use strict';

  window.Coop = window.Coop || { Modules: {} };

  var selector = '[data-reset-input]';

  var resetInput = function($el, options) {
    this.init($el, options);
    return this;
  };

  resetInput.prototype = {
    init: function($el, options) {
      this.$input = $el;
      this.$button = null;

      this.addId();
      this.addButton();
      this.updateBtnVisibility();
      this.bindEvents();
    },
    bindEvents: function() {
      var self = this;

      this.$input
        .off('keyup.resetInput focus.resetInput change.resetInput')
        .on('keyup.resetInput focus.resetInput change.resetInput', function () {
          self.updateBtnVisibility();
        });

      this.$button
        .off('click.resetInput keyup.resetInput')
        .on('click.resetInput', function(e) {
          e.preventDefault();
          self.$input.val('').focus().trigger('change');
          self.updateBtnVisibility();
        })
        .on('keyup.resetInput', function(e) {
          if (e.which === 32) {
            e.preventDefault();
            $(this).trigger('click');
          }
        });
    },
    addId: function() {
      if (!this.$input.attr('id')) {
        this.$input.attr('id', this.generateId);
      }
    },
    generateId: function() {
      return "resetInput-" + Math.random().toString(36).substr(2, 8);
    },
    addButton: function() {
      var id = this.$input.attr('id'),
          container = this.$input.data('reset-input') || false;

      this.$button = $('.btn-reset[aria-controls="' + id + '"]');

      if (!this.$button.length) {
        this.$button = $('<button class="btn-reset" type="button" aria-controls="' + id + '"><span class="icon icon-cancel" tabindex="3"></span><span class="visuallyhidden">Clear</span></button>');

        if (container && $(container).length) {
          $(container).append(this.$button);
        }
        else {
          this.$input.after(this.$button);
        }
      }
    },
    updateBtnVisibility: function() {
      if ( this.$input.val().trim().length > 0 ) {
        this.$button.addClass('is-shown');
        this.$input.addClass('has-reset-btn');
      } else {
        this.$button.removeClass('is-shown');
        this.$input.removeClass('has-reset-btn');
      }
    }
  };

  Coop.Modules._resetInput = resetInput;

  Coop.Modules.resetInput = {
    init: function() {
      return $(selector).each(function() {
        $(this).data('resetInputModule', new resetInput($(this), $(this).data()));
      });
    }
  };
}());
